import { render, staticRenderFns } from "./character.vue?vue&type=template&id=86efbc4e&"
import script from "./character.vue?vue&type=script&lang=js&"
export * from "./character.vue?vue&type=script&lang=js&"
import style0 from "./character.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports